/**
 * Protected Route Component - Restricts access to authenticated users
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getPortalMode } from '../config/portal';

const ProtectedRoute = ({ children, requireAdmin = false, requireStaff = false }) => {
  const { isAuthenticated, isAdmin, isStaff, loading } = useAuth();
  const location = useLocation();
  const portalMode = getPortalMode();
  const useAdminLogin = portalMode === 'admin' || requireAdmin || location.pathname.startsWith('/admin');
  const loginPath = useAdminLogin ? '/admin/login' : '/login';

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  if (portalMode === 'admin' && !isAdmin) {
    return <Navigate to="/admin/login" replace />;
  }

  if (portalMode === 'customer' && isStaff && !requireAdmin) {
    return <Navigate to="/login" replace />;
  }

  // Check admin access
  if (requireAdmin && !isAdmin) {
    return <Navigate to={portalMode === 'admin' ? '/admin/login' : '/dashboard'} replace />;
  }

  // Check staff access (includes admin)
  if (requireStaff && !isStaff) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;

